import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// Types
interface Product {
  id: string;
  productName: string;
}

interface Bucket {
  id: string;
  bucketName: string;
}

export interface ProductBucketState {
  products: Product[];
  buckets: Bucket[];
  loading: boolean;
  error: string | null;
}

// Initial state
export const productBucketInitialState: ProductBucketState = {
  products: [],
  buckets: [],
  loading: false,
  error: null,
};

// Slice
const productBucketSlice = createSlice({
  name: 'productBucket',
  initialState: productBucketInitialState,
  reducers: {
    // Product actions
    fetchProductsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProductsSuccess: (state, action: PayloadAction<Product[]>) => {
      state.products = action.payload;
      state.loading = false;
    },
    fetchProductsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bucket actions
    fetchBucketsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchBucketsSuccess: (state, action: PayloadAction<Bucket[]>) => {
      state.buckets = action.payload;
      state.loading = false;
    },
    fetchBucketsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Actions
export const {
  fetchProductsRequest,
  fetchProductsSuccess,
  fetchProductsFailure,
  fetchBucketsRequest,
  fetchBucketsSuccess,
  fetchBucketsFailure,
} = productBucketSlice.actions;

// Reducer
export default productBucketSlice.reducer;
